import PptxGenJS from "pptxgenjs";
import unitsIcon from "../../../assets/units.png";
import fetchImageAsBase64 from "../../../../../utils/fetchImageAsBase64";
import convertS3ToCloudFront from "../../../../../utils/convertS3ToCloudFront";
//images
import pptSliderCornerLogo from "../../../assets/pptSlideCornerLogo.png";
import coverImage from "../../../assets/pptSlide1.jpg";
import bottomRightLogo from "../../../assets/pptSlide11.png";
import welcomeBackground from "../../../assets/pptSlide111.jpg";
import welcomeText from "../../../assets/welcomeText.png";
import welcomeHoarding from "../../../assets/welcomeHoarding.png";
import svg1 from "../../../assets/svg1.png";
import clientPageImage from "../../../assets/clientPageImage.png";
import clientSpecificBorderLine from "../../../assets/clientSpecificBorderLines.png";
import hoardingIcon from "../../../assets/hoardingIcon.png";
import locationIcon from "../../../assets/locationIcon.png";
import calendarIcon from "../../../assets/calendarIcon.png";
import rupeeIcon from "../../../assets/rupeeIcon.png";
import contactRightImage from "../../../assets/contactRightImage.png";
import contactUsTitle from "../../../assets/contactUsTitle.png";
import pptSlideLast from "../../../assets/pptSlideLast.png";
import thankYouImage from "../../../assets/thankYouImage.png";
import amitImage from "../../../assets/amit@4x.png";
import meetImage from "../../../assets/meet@4x.png";
import niravImage from "../../../assets/nirav@4x.png";
import pankajImage from "../../../assets/pankaj@4x.png";
import sagarImage from "../../../assets/sagar@4x.png";
import saurabhImage from "../../../assets/saurabh@4x.png";
import vrajImage from "../../../assets/vraj@4x.png";
import yellowspotImage from "../../../assets/yellowspot@4x.png";
import getProposalAvailableFromLabel from "../../../../../utils/getProposalAvailableFromLabel";
import moment from "moment";
import store from "../../../../toolkit/store";
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

async function generatePresentation(
  proposalInventories,
  clientName,
  PR,
  proposalMainData,
  isEmail = false,
  setShowLoader,
  setPptURL,
  userId = null
) {
  let isGenerateLink = false;
  // if (proposalMainData?.pptLink) {
  //   isGenerateLink = true;
  // }
  console.log("isGenerateLink ", isGenerateLink);

  let pptx;

  if (!isGenerateLink) {
    setShowLoader(true);
  }
  pptx = new PptxGenJS();
  const hasSpecialRateChanged = proposalInventories.some(
    (ele) => ele?.invId?.ratePerMonth !== ele?.specialRate
  );

  // Fetch images as Base64
  const coverImageBase64 = await fetchImageAsBase64(coverImage);
  const bottomRightLogoBase64 = await fetchImageAsBase64(bottomRightLogo);
  const welcomeBackgroundBase64 = await fetchImageAsBase64(welcomeBackground);
  const welcomeTextBase64 = await fetchImageAsBase64(welcomeText);
  const welcomeHoardingBase64 = await fetchImageAsBase64(welcomeHoarding);
  const svg1Base64 = await fetchImageAsBase64(svg1);
  const pptSliderCornerLogoBase64 = await fetchImageAsBase64(
    pptSliderCornerLogo
  );
  const clientPageImageBase64 = await fetchImageAsBase64(clientPageImage);
  const clientSpecificBorderLineBase64 = await fetchImageAsBase64(
    clientSpecificBorderLine
  );
  const hoardingIconBase64 = await fetchImageAsBase64(hoardingIcon);
  const locationIconBase64 = await fetchImageAsBase64(locationIcon);
  const rupeeIconBase64 = await fetchImageAsBase64(rupeeIcon);
  const unitsIconBase64 = await fetchImageAsBase64(unitsIcon);
  const calendarIconBase64 = await fetchImageAsBase64(calendarIcon);
  const contactRightImageBase64 = await fetchImageAsBase64(contactRightImage);
  const contactUsTitleBase64 = await fetchImageAsBase64(contactUsTitle);

  // Ensure we always have the latest userId from Redux if not provided
  if (!userId) {
    try {
      const state = store.getState();
      userId = state?.user?._id || null;
    } catch (e) {
      // ignore store access errors, will fall back to default image
    }
  }

  console.log("userId:: ", userId);

  // Choose dynamic contact details image based on userId
  let contactDetailsImage = yellowspotImage;
  if (userId === "6655da0d21d3e92d1b400e27") {
    // Amit
    contactDetailsImage = amitImage;
  } else if (userId === "668bb8a8dc1b17763bfc16bd") {
    // Pankaj
    contactDetailsImage = pankajImage;
  } else if (userId === "668bb8a98846df09d6649fc3") {
    // Meet
    contactDetailsImage = meetImage;
  } else if (userId === "668bb8a86a5e8031326ead83") {
    // Saurabh
    contactDetailsImage = saurabhImage;
  } else if (userId === "6655da3e6826d0540967b9ce") {
    // Sagar
    contactDetailsImage = sagarImage;
  } else if (userId === "68636e2a8e9cb38030bb14f7") {
    // Nirav
    contactDetailsImage = niravImage;
  } else if (userId === "6655da0db7fa235637d8803a") {
    // Vraj
    contactDetailsImage = vrajImage;
  }

  const contactDetailsBase64 = await fetchImageAsBase64(contactDetailsImage);
  const pptSlideLastBase64 = await fetchImageAsBase64(pptSlideLast);
  const thankYouImageBase64 = await fetchImageAsBase64(thankYouImage);

  //🤡🤡 Cover slide
  const coverSlide = pptx.addSlide();
  coverSlide.addImage({
    data: coverImageBase64,
    x: 0,
    y: 0,
    w: "100%",
    h: "100%",
  });
  coverSlide.addImage({
    data: bottomRightLogoBase64,
    x: "94%",
    y: "89.4%",
    w: 0.6,
    h: 0.6,
  });

  //🤡🤡 Welcome slide
  const welcomeSlide = pptx.addSlide();
  welcomeSlide.background = { data: welcomeBackgroundBase64, opacity: 50 };
  let textWelcomeX = 0.4;
  let textWelcomeY = 0.23;
  welcomeSlide.addImage({
    data: welcomeTextBase64,
    x: textWelcomeX,
    y: textWelcomeY,
    h: 1.2,
    w: 2.8,
  });
  let welcomeInfo1 =
    "YellowSpot emerged as a collaborative effort between Het Graphics and Khushi Advertising. Our Strategic alliance brings together two industry leaders, establishing one of the most formidable media houses in Gujarat. ";
  let welcomeInfo2 =
    "We offer 400+ premium back-lit outdoor media throughout the city of Ahmedabad, located in high-traffic locations, and strategically placed in every neighborhood.";
  welcomeSlide.addText(welcomeInfo1, {
    x: textWelcomeX,
    y: textWelcomeY + 2,
    w: 4,
    fontSize: 17,
    wrap: true,
    color: "FFFFFF",
  });
  welcomeSlide.addText(welcomeInfo2, {
    x: textWelcomeX,
    y: textWelcomeY + 3.8,
    w: 4,
    fontSize: 17,
    wrap: true,
    color: "FFFFFF",
  });
  welcomeSlide.addImage({
    data: welcomeHoardingBase64,
    x: 4,
    y: -0.28,
    w: "60%",
    h: "110%",
  });
  welcomeSlide.addImage({
    data: svg1Base64,
    x: "90%",
    y: -0.3,
    w: 1.3,
    h: 1.3,
  });
  welcomeSlide.addImage({
    data: pptSliderCornerLogoBase64,
    x: "80%",
    y: "88%",
    w: 2,
    h: 0.7,
  });

  //🤡🤡 Client Specific Slide
  const clientSlide = pptx.addSlide();
  clientSlide.background = { data: welcomeBackgroundBase64, opacity: 50 };
  clientSlide.addImage({
    data: svg1Base64,
    x: "90%",
    y: -0.3,
    w: 1.3,
    h: 1.3,
  });
  clientSlide.addImage({
    data: clientPageImageBase64,
    x: 0,
    y: 1,
    w: "100%",
    h: 1.8,
  });
  clientSlide.addImage({
    data: clientSpecificBorderLineBase64,
    x: 0,
    y: 3.9,
    w: "100%",
    h: 1,
  });
  let clientStmnt =
    "This proposal is tailored specifically to meet the campaign requirements of";
  let clientNamePPT = `${clientName}`;
  clientSlide.addText(clientStmnt, {
    x: 2.1,
    y: 3,
    w: 6,
    h: 1,
    fontSize: 21,
    wrap: true,
    color: "FFFFFF",
    align: pptx.AlignH.center,
  });
  clientSlide.addText(clientNamePPT, {
    x: 1.8,
    y: 4.5,
    w: 6,
    fontSize: 40,
    bold: true,
    wrap: true,
    color: "FFFFFF",
    align: pptx.AlignH.center,
  });

  let textVal;
  for (const data of proposalInventories) {
    const slide = pptx.addSlide();
    slide.background = { data: welcomeBackgroundBase64, opacity: 50 };
    slide.addImage({
      data: svg1Base64,
      x: "90%",
      y: -0.3,
      w: 1.3,
      h: 1.3,
    });

    const imgBase64 = await fetchImageAsBase64(data?.invId?.img);
    slide.addImage({
      data: imgBase64,
      x: 0.2,
      y: 0.3,
      w: 6.1,
      h: "90%",
    });

    const textX = 6.1;
    let textY = 1.8;
    const lineHeight = 0.7;

    slide.addImage({
      data: hoardingIconBase64,
      x: textX + 0.3,
      y: textY,
      w: 0.2,
      h: 0.3,
    });
    textVal = `${data?.invId?.width} X ${data?.invId?.height} ${
      data?.invId?.Illu ?? ""
    } ${data?.invId?.typeOfMedia?.name}`;
    slide.addText(textVal, {
      x: textX + 0.6,
      y: textY + 0.15,
      w: 3.1,
      fontSize: 15,
      fontFace: "Montserrat Medium",
      wrap: true,
      color: "FFFFFF",
    });
    textY += lineHeight;

    slide.addImage({
      data: locationIconBase64,
      x: textX + 0.3,
      y: textY,
      w: 0.2,
      h: 0.3,
    });
    textVal = `${data?.invId?.locations?.name} `;
    slide.addText(textVal, {
      x: textX + 0.6,
      y: textY + 0.15,
      w: 3.1,
      fontSize: 15,
      fontFace: "Montserrat Medium",
      wrap: true,
      color: "FFFFFF",
    });
    textY += lineHeight;

    if (!PR && !hasSpecialRateChanged) {
      slide.addImage({
        data: rupeeIconBase64,
        x: textX + 0.3,
        y: textY,
        w: 0.2,
        h: 0.3,
      });
      textVal = `${data?.invId?.ratePerMonth} /- PM`;
      slide.addText(textVal, {
        x: textX + 0.6,
        y: textY + 0.15,
        w: 3.1,
        fontSize: 15,
        fontFace: "Montserrat Medium",
        wrap: true,
        color: "FFFFFF",
      });
      textY += lineHeight;
    }

    if (new RegExp(data?.invId?.typeOfMedia?.name, "i").test("kiosk")) {
      slide.addImage({
        data: unitsIconBase64,
        x: textX + 0.3,
        y: textY,
        w: 0.3,
        h: 0.3,
      });
      textVal = `${data?.invId?.unit} units`;
      slide.addText(textVal, {
        x: textX + 0.6,
        y: textY + 0.15,
        w: 3.1,
        fontSize: 15,
        fontFace: "Montserrat Medium",
        wrap: true,
        color: "FFFFFF",
      });
      textY += lineHeight;
    }

    slide.addImage({
      data: calendarIconBase64,
      x: textX + 0.3,
      y: textY,
      w: 0.2,
      h: 0.3,
    });
    textVal = `Available From - ${getProposalAvailableFromLabel(data?.invId)}`;
    slide.addText(textVal, {
      x: textX + 0.6,
      y: textY + 0.15,
      w: 3.1,
      fontSize: 15,
      fontFace: "Montserrat Medium",
      wrap: true,
      color: "FFFFFF",
    });
    textY += lineHeight;

    slide.addImage({
      data: pptSliderCornerLogoBase64,
      x: "80%",
      y: "88%",
      w: 2,
      h: 0.7,
    });
  }

  const contactInfo = pptx.addSlide();
  contactInfo.background = { data: welcomeBackgroundBase64, opacity: 50 };
  contactInfo.addImage({
    data: contactRightImageBase64,
    x: "50%",
    y: 0,
    w: 5,
    h: "100%",
  });
  contactInfo.addImage({
    data: contactUsTitleBase64,
    x: 0.2,
    y: 0.4,
    w: 5,
    h: 1.6,
  });
  contactInfo.addImage({
    data: svg1Base64,
    x: "90%",
    y: -0.3,
    w: 1.3,
    h: 1.3,
  });
  contactInfo.addImage({
    data: contactDetailsBase64,
    x: 0.2,
    y: 2.0,
    w: 4.8,
    h: 3,
  });

  //🤡🤡 Thank you Slide
  const ThankYouSlide = pptx.addSlide();
  ThankYouSlide.background = { data: welcomeBackgroundBase64, opacity: 50 };
  ThankYouSlide.addImage({
    data: pptSlideLastBase64,
    x: 1,
    y: "23%",
    w: 9,
    h: "48%",
  });
  ThankYouSlide.addImage({
    data: thankYouImageBase64,
    x: "46%",
    y: "40%",
    w: 3,
    h: 0.7,
  });
  const fileName = `${clientName}_Proposal_${moment().format(
    "YYYY-MM-DD"
  )}.pptx`;
  let blob;
  const mime =
    "application/vnd.openxmlformats-officedocument.presentationml.presentation";

  if (!isEmail) {
    // Generate the PPTX file and save it locally if not for email
    await pptx.writeFile({
      fileName,
    });

    // Create a blob from the presentation file
    blob = await pptx.write("blob");
  } else {
    // Changed the condition to 'else' for clarity since 'isEmail' is either true or false
    // Generate the blob for the PPTX file for the email case
    blob = await pptx.write("blob"); // Ensure blob is generated in both scenarios

    // Prepare the request body for the policy upload API
    const requestBody = {
      fileName: fileName,
      mime: mime,
    };

    try {
      // Fetch the upload policy from the API
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/uploadPolicyForEmails`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (!response.ok) {
        console.error(`HTTP error! Status: ${response.status}`);
        return;
      }

      const data = await response.json();

      const formData = new FormData();
      const contentType = mime;

      // Only use fields from the policy - do not add any extra fields (e.g. content-type)
      // or S3 returns "Invalid according to Policy: Extra input fields"
      for (const [key, value] of Object.entries(data.data.fields)) {
        if (key.toLowerCase() === "content-type") {
          formData.set(key, contentType);
        } else {
          formData.set(key, value);
        }
      }

      // Create the file from the blob correctly
      const file = new File([blob], fileName, { type: mime });
      formData.append("file", file);

      // Set the URL where the file should be uploaded
      setPptURL(
        convertS3ToCloudFront(`${data.data.url}/${data.filePath}`),
      );

      try {
        // Upload the file to the final URL with the correct form data
        const almostFinalResponse = await fetch(data.data.url, {
          method: "POST",
          body: formData,
        });

        if (almostFinalResponse.ok) {
          console.log("File uploaded successfully.");
        } else {
          console.log(
            "Error occurred:",
            almostFinalResponse.status,
            almostFinalResponse.statusText
          );
        }
      } catch (error) {
        console.log("Error occurred while uploading file:", error);
      }
    } catch (error) {
      console.error("Error fetching upload policy:", error);
    }
  }

  // if (!isEmail && isGenerateLink) {
  //   const url = proposalMainData?.pptLink;

  //   const anchor = document.createElement("a");
  //   anchor.href = url;
  //   anchor.download = "downloaded-file.xlsx";
  //   document.body.appendChild(anchor);
  //   anchor.click();
  //   document.body.removeChild(anchor);
  // }
  setShowLoader(false);
}

export default generatePresentation